<template>
    <custom-dialog width="485px" :showClose="true" title="收货地址" v-if="visibleObj.addressDialog"
        :visible="visibleObj.addressDialog" @close="dialogVisible('addressDialog')">
        <div slot="content" v-loading="loading">
            <el-form :model="addressForm" :rules="rules" ref="addressForm" label-width="80px" class="demo-ruleForm">
                <el-form-item label="收件人" prop="consigneeName">
                    <custom-input v-model="addressForm.consigneeName"></custom-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <custom-input v-model="addressForm.phone" maxlength="11"></custom-input>
                </el-form-item>
                <el-form-item label="配送区域" prop="addressRegion">
                    <el-cascader style="width:100%" v-model="addressForm.addressRegion" :props="regionProps"
                        placeholder="请选择省市区/县" :options="addressOptions" filterable clearable @change="cascaderChange" />
                </el-form-item>
                <el-form-item label="详细地址" prop="detailedAddress">
                    <custom-input v-model="addressForm.detailedAddress" placeholder="请输入详细地址" />
                </el-form-item>
            </el-form>
            <div class="btns">
                <div class="del-icon" :class="dialogObj.addressType == 'add' ? 'disabled' : ''">
                    <span class="iconfont icon-shanch" @click="handleDelete"></span>
                </div>
                <div>
                    <custom-button type="info" size="medium" @click="dialogVisible('addressDialog')">取消</custom-button>
                    <custom-button type="primary" size="medium" @click="saveAdd">确定</custom-button>
                </div>
            </div>
        </div>
        <div slot="footer"> </div>
    </custom-dialog>
</template>
  
<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import CustomInput from '@/components/CustomInput'
import { provincesList } from "@/api/region"; // 获取区域请求
import { patientDTO } from '@/DTO/index'
import { deepClone, isNull } from "@/utils/validateBase";
import { validatePhone } from "@/utils/regexp" // 自定义验证
import { Utils } from '../../../utils/utils';
export default {
    // 定义引入的组件
    components: { CustomDialog, CustomInput },
    props: {
        visibleObj: {
            type: Object,
            default: () => { return {} }
        },
        dialogObj: {
            type: Object,
            default: () => { return {} }
        },
    },
    data() {
        return {
            loading: false,
            addressForm: {
                consigneeName:'',
                phone:'',
                addressRegion:[],
                detailedAddress:''
            },
            rules: {
                consigneeName: [{ required: true, message: '请输入收件人', trigger: 'blur' }],
                phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
                addressRegion: [{ required: true, message: '配送区域不能为空！', trigger: 'change' }],
                detailedAddress: [{ required: true, message: '详细地址不能为空！', trigger: 'blur' }],
            },
            addressOptions: [],
            regionProps: { label: "provincesName", value: "provincesId" }, // 区域选择配置
        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    async created() {
        this.loading = true
        let list = await Utils.getProvincesList()
        this.listToTree(list);
        this.loading = false
        if (this.dialogObj.addressType == 'edit') {
            let addressObj = this.dialogObj.addressObj
            if (!isNull(addressObj && !isNull(addressObj.deliveryMemberId))) {
                let addressRegion = []
                addressRegion[0] = addressObj.provinceId
                addressRegion[1] = addressObj.cityId
                addressRegion[2] = addressObj.regionId
                if (!isNull(addressObj.scopeId)) addressRegion[3] = addressObj.scopeId
                this.addressForm = { ...addressObj, addressRegion }
            }
        } else {
            this.addressForm.consigneeName = isNull(this.dialogObj.patientInfo.patientName) ? '' : this.dialogObj.patientInfo.patientName
            this.addressForm.phone = isNull(this.dialogObj.patientInfo.phone) ? '' : this.dialogObj.patientInfo.phone
        }
        // this.getProvincesList().then(res => {
        //     if(this.dialogObj.addressType == 'edit'){
        //         let addressObj = this.dialogObj.addressObj
        //         if (!isNull(addressObj && !isNull(addressObj.deliveryMemberId))) {
        //             let addressRegion = []
        //             addressRegion[0] = addressObj.provinceId
        //             addressRegion[1] = addressObj.cityId
        //             addressRegion[2] = addressObj.regionId
        //             if (!isNull(addressObj.scopeId)) addressRegion[3] = addressObj.regionId
        //             this.addressForm = { ...addressObj, addressRegion }
        //         }
        //     }

        // }) // 请求区域列表
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        cascaderChange(val) {
            console.log(val, 3333);
        },
        /**
         * 关闭
        */
        dialogVisible(name) {
            this.$emit("close", name);
        },
        // 请求所有区域列表列表
        getProvincesList() {
            this.loading = true
            return new Promise(async (resolve, reject) => {
                let { rows, code } = await provincesList();
                if (code == 200) {
                    this.$session.set('provincesList', rows)
                    resolve()
                    this.listToTree(rows);
                } else {
                    this.loading = false
                }
            })

        },
        // 链式结构转树形结构
        listToTree(list) {
            // 省份列表
            list.forEach(item => { if (item.type == "0") this.addressOptions.push(item) });
            // 城市列表
            list.forEach(item => {
                if (item.type == "1") {
                    this.addressOptions.forEach(items => {
                        if (item.parentId == items.provincesId) items.children.push(item);
                    });
                }
            });
            // 区/县列表
            list.forEach(item => {
                if (item.type == "2") {
                    this.addressOptions.forEach(items => {
                        items.children.forEach(itemm => {
                            if (item.parentId == itemm.provincesId) itemm.children.push(item);
                        });
                    })
                }
            });
            // 范围列表
            list.forEach(item => {
                if (item.type == "3") {
                    item.children = null
                    this.addressOptions.forEach(items => {
                        items.children.forEach(itemm => {
                            itemm.children.forEach(itemn => {
                                if (item.parentId == itemn.provincesId) itemn.children.push(item);
                            })
                        });
                    })
                }
            });
            // 没有第四级的将第三级children设置为null
            this.addressOptions.forEach(items => {
                items.children.forEach(itemm => {
                    itemm.children.forEach(itemn => {
                        if (itemn.children.length == 0) itemn.children = null;
                    })
                });
            })
            this.loading = false
        },
        /**
        * 保存
        */
        saveAdd() {
            this.$refs['addressForm'].validate((valid) => {
                if (valid) {
                    let params = deepClone(this.addressForm)
                    params.provinceId = params.addressRegion[0];
                    params.cityId = params.addressRegion[1];
                    params.regionId = params.addressRegion[2];
                    params.scopeId = params.addressRegion[3];
                    delete params.provinceName
                    delete params.cityName
                    delete params.regionName
                    delete params.scopeName
                    params.patientId = this.dialogObj.patientInfo.patientId
                    if (isNull(this.addressForm.deliveryMemberId)) {
                        patientDTO.addressAdd(params).then(res => {
                            let { code, data } = res;
                            if (code == 200) {
                                this.$message.success("创建收货地址成功！");
                                this.$bus.$emit('addressChange', data)
                                this.$emit("close", 'addressDialog');
                            }
                            this.$refs['addressForm'].resetFields();
                        })

                    } else {
                        patientDTO.addressEdit(params).then(res => {
                            let { code, data } = res;
                            if (code == 200) {
                                this.$message.success("修改收货地址成功！");
                                this.$bus.$emit('addressChange', data.deliveryMemberId)
                                this.$emit("close", 'addressDialog');
                            }
                            this.$refs['addressForm'].resetFields();
                        })
                    }
                } else return false;
            })
        },
        /**
         * 删除
         */
        async handleDelete() {
            let { code, data } = await patientDTO.addressDelete(this.dialogObj.addressObj.deliveryMemberId)
            if (code == 200) {
                this.$message.success("删除成功！");
                this.$bus.$emit('addressDelete')
                this.$emit("close", 'addressDialog');
            }
        },
    },
}
</script>
<style lang="less" scoped>
.el-form-item {
    margin-bottom: 16px;
}

.btns {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .del-icon {
        width: 32px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #D3D3D5;
        text-align: center;
        line-height: 32px;
    }

    .disabled {
        cursor: not-allowed !important;
        pointer-events: none;
    }
}
</style>